module.exports = __webpack_public_path__ + "img/sun-behind-cloud.f2aef27d.png";